import { LoggerProvider, LogLevel } from '@wkda/logger-core';

export class ConsoleLoggerProvider extends LoggerProvider {
  getLogger(loggerName) {
    return {
      log(logRecord) {
        if (logRecord.level === LogLevel.ERROR) console.error(logRecord);
        else console.log(logRecord);
      },
      name: loggerName,
    };
  }
}
